import { Alert, Code, FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function SplitDatasetInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Train ratio</FieldLabel>
      <TextInput mono type="number" value={c.ratio ?? 0.8} onChange={(v) => u({ ratio: Number(v) })} />
      <FieldLabel hint="Split independently within each value of this column, so the train/test ratio holds per-group">Stratify by</FieldLabel>
      <ColSelect value={c.stratify} onChange={(v) => u({ stratify: v })} placeholder="— unstratified —" />
      <FieldLabel>Random seed</FieldLabel>
      <TextInput mono value={c.seed ?? '42'} onChange={(v) => u({ seed: v })} />
      <FieldLabel hint="Every row gets 'train' or 'test' written here">Output column</FieldLabel>
      <TextInput mono value={c.target ?? 'split'} onChange={(v) => u({ target: v })} />
      <Alert kind="info" style={{ marginTop: 12 }}>
        All rows pass through — none are dropped. This step only labels each row
        <Code>train</Code> or <Code>test</Code> in the output column above.
      </Alert>
    </div>
  );
}
